import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Function to toggle the dropdown
  const toggleDropdown = () => {
    setDropdownOpen(prev => !prev);
  };

  // Function to close the dropdown
  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  // Check if the screen width is less than or equal to 600px
  const checkIfMobile = () => {
    setIsMobile(window.innerWidth <= 600);
  };

  // Add event listener for window resize to detect mobile devices
  useEffect(() => {
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  return (
    <header className="header-container">
      <nav>
        {!isMobile ? (
          // Render dropdown for non-mobile devices
          // <div
          //   className="dropdown"
          //   onClick={toggleDropdown} // Only toggle dropdown on click
          // >
          //   <Link to="#" className="dropdown-link">
          //     Portofoliu
          //     <span className="dropdown-icon">▼</span>
          //   </Link>
          //   {isDropdownOpen && (
          //     <div className="dropdown-menu">
          //       <a href="#moon" onClick={closeDropdown}>Luna / The Moon</a>
          //       <a href="#abstract" onClick={closeDropdown}>Tablouri abstracte</a>
          //       <a href="#people" onClick={closeDropdown}>Chipuri și Povesti</a>
          //       <a href="#pouring" onClick={closeDropdown}>Tablouri pouring Art</a>
          //       <a href="#flowers" onClick={closeDropdown}>Tablouri cu flori</a>
          //     </div>
          //   )}
          // </div>
          <Link to="/" className="simple-link">
            Portofoliu
          </Link>
        ) : (
          // Render simpler link for mobile devices
          <Link to="/" className="simple-link">
            Portofoliu
          </Link>
        )}

        <Link to="/about">Despre mine</Link>
        <Link to="/contact">Contact</Link>
      </nav>
      <Link to="/" className="logo-link">
        <h1>CLAUDIU T</h1>
      </Link>
      <div className="tag-line">
        <span>Fine art</span>
      </div>
    </header>
  );
};

export default Header;
